import { cloneDeep } from "lodash";
const logState = (message, { color }, ...args) => {
  const argsCopy = cloneDeep(args);
  console.log(`%c${message}`, `color: ${color}`, ...argsCopy);
};

export { logState };
